import PurchaseOrderLineForPrinter from "./purchase-order-line-for-printer";

export default class PurchaseOrderForPrinter{
    poCode : string;
    externalPoCode : string;
    shortClientName : string;
    clientName : string;
    clientAddress : string;
    clientLogoUrl : string;
    warehouseCode : string;
    warehouseName : string;
    warehouseAddress : string;
    vendorName : string;
    vendorPhone : string;
    vendorAddress : string;
    conditionTypeName:string;
    items : Array<PurchaseOrderLineForPrinter>;
}